import React, { useRef } from "react";
import { CustomText, Input, InputDate } from "../../components";
import { FormFull } from "form-full";
import { fonts } from "../../config";

import { masks, validations } from "../../utils";
import Styles from "./styles";
import { Grid } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { customModal } from "../../components/modals/utils";

function GuestHome() {
  const [fileName, setFileName] = React.useState<any>({});
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const fileRef = useRef<any | null>(null);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64Image = e?.target?.result as string;

        setFileName({ base: event.target.files?.[0].name });
        fileRef.current = { base: base64Image };
      };
      reader.readAsDataURL(file);
    }
  };

  const openModalViewImg = () => {
    customModal.setInfos(
      fileName.base,
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar"
      },
      null,
      <>
        <div
          style={{
            marginInline: "20px",
            borderRadius: "5px",
            maxHeight: "80vh",
            maxWidth: "80vw",
            height: "480px",
            width: "400px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundImage: `url(${fileRef.current.base})`
          }}
        />
      </>,
      false,
      false
    );
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={4} xl={5}>
          <Styles.Container>
            <CustomText
              style={{ paddingBottom: "5px" }}
              fontSize={2.25}
              fontFamily={fonts.bold}
              textColor="#4D585A"
            >
              Dados da Estadia
            </CustomText>
            <CustomText
              style={{ paddingBottom: "25px" }}
              fontSize={1.75}
              fontFamily={fonts.regular}
              textColor="#24272A"
            >
              Validação dos dados básicos do locatário primário e do imóvel:
            </CustomText>

            <CustomText
              style={{ paddingBottom: "25px" }}
              fontSize={1.75}
              fontFamily={fonts.bold}
              textColor="#8D9B9C"
            >
              DADOS DO LOCATÁRIO (PRIMÁRIO)
            </CustomText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} lg={12} xl={6}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  NOME COMPLETO
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  Leandro Bittencourt
                </CustomText>
                <Styles.Line></Styles.Line>
              </Grid>
              <Grid item xs={12} sm={6} lg={12} xl={6}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  CPF
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  984.302.665-03
                </CustomText>
                <Styles.Line></Styles.Line>
              </Grid>
              <Grid item xs={12} sm={6} lg={12} xl={6}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  DATA NASCIMENTO
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  19/03/1987
                </CustomText>
                <Styles.Line></Styles.Line>
              </Grid>
              <Grid item xs={12} sm={6} lg={12} xl={6}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  E-MAIL
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  l.bittencourt@email.com.br
                </CustomText>
                <Styles.Line></Styles.Line>
              </Grid>
              <Grid item xs={12} sm={12}>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={1.75}
                  fontFamily={fonts.semibold}
                  textColor="#4D585A"
                >
                  TELEFONE
                </CustomText>
                <CustomText
                  style={{ paddingBottom: "6px" }}
                  fontSize={2}
                  fontFamily={fonts.semibold}
                  textColor="#24272A"
                >
                  (48) 99941 0126
                </CustomText>
                <Styles.Line></Styles.Line>
              </Grid>
            </Grid>
          </Styles.Container>
        </Grid>

        <Grid item xs={12} lg={8} xl={7}>
          <Styles.Container>
            <CustomText
              style={{ paddingBottom: "5px" }}
              fontSize={2.25}
              fontFamily={fonts.bold}
              textColor="#4D585A"
            >
              Complemento de Dados
            </CustomText>
            <CustomText
              style={{ paddingBottom: "12px" }}
              fontSize={1.75}
              fontFamily={fonts.regular}
              textColor="#24272A"
            >
              A seguir, preencha seus dados adicionais para confirmar seu acesso
              como hóspede acompanhante:
            </CustomText>
            <FormFull onSubmit={(data) => {}}>
              <Grid alignItems="flex-end" container spacing={2}>
                <Grid item xs={12} md={6} lg={3}>
                  <Input
                    validation={validations.isValidFullname}
                    required={"Campo Obrigatório"}
                    label="NOME COMPLETO"
                    name={"fullName"}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Input
                    validation={validations.validateCPF}
                    mask={masks.CPF}
                    required={"Campo Obrigatório"}
                    label="CPF"
                    name={"cpf"}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <Input
                    validation={validations.isEmailValid}
                    required={"Campo Obrigatório"}
                    label="E-MAIL"
                    name={"email"}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <InputDate
                    maxDate={new Date()}
                    required={"Campo Obrigatório"}
                    label="DATA NASCIMENTO"
                    name={"birthday"}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Input
                    mask={masks.inputMaskTELWithDDD}
                    required={"Campo Obrigatório"}
                    label="TELEFONE"
                    name={"phone"}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <CustomText
                    fontSize={1.75}
                    fontFamily={fonts.semibold}
                    textColor="#4D585A"
                  >
                    CADASTRO DA FACIAL**
                  </CustomText>
                  <Styles.InputImage>
                    <Styles.InputImageClick htmlFor={"fileInput"}>
                      {fileName?.base ? (
                        <CustomText
                          style={{
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            display: "block"
                          }}
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          {fileName?.base}
                        </CustomText>
                      ) : (
                        <CustomText
                          textColor="#4D585A"
                          fontSize={2}
                          fontFamily={fonts.medium}
                        >
                          Clique aqui para cadastrar sua facial
                        </CustomText>
                      )}

                      <input
                        id="fileInput"
                        type="file"
                        accept="image/jpeg, image/png"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                      />
                    </Styles.InputImageClick>

                    {fileName?.base && (
                      <Styles.InputView
                        endIcon={<Visibility />}
                        fullWidth={false}
                        onClick={() => openModalViewImg()}
                      >
                        Visualizar
                      </Styles.InputView>
                    )}
                  </Styles.InputImage>
                </Grid>
              </Grid>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "8px",
                  marginBottom: "16px"
                }}
              >
                <Styles.Back
                  fullWidth={false}
                  action="clear"
                  onClick={() => {
                    fileRef.current = { base: fileRef.current.base };
                    setFileName({ base: fileName.base });
                  }}
                >
                  Voltar
                </Styles.Back>
                <Styles.Clear
                  fullWidth={false}
                  action="clear"
                  onClick={() => {
                    if (fileInputRef?.current?.value) {
                      fileInputRef.current.value = "";
                    }

                    fileRef.current = null;
                    setFileName({});
                  }}
                >
                  Limpar Campos
                </Styles.Clear>
                <Styles.SendForm
                  disabled={Object.keys(fileName).length < 1}
                  fullWidth={false}
                  action="submit"
                >
                  Confirmar dados
                </Styles.SendForm>
              </div>
            </FormFull>
          </Styles.Container>
        </Grid>
      </Grid>
    </>
  );
}

export default GuestHome;
